import React from 'react';
import { Modal,Image, Container, Row } from 'react-bootstrap';
import TitleLight from '../../components/Text/TitleLight';
import MainStyles from '../../styles/MainStyles';
import i18n from '../../locales/index';
import TitleHead from '../Text/TitleHead';
import BlueButton from '../Buttons/BlueButton';
import BadgeOK from '../../assets/images/group3.png'
import BadgeError from '../../assets/images/group6.png'
import WhiteButton from '../../components/Buttons/WhiteButton';

const ModalDetails = ({show, handleClose, guaranteeStamp,infoPeriod, detail, image, text, button}) => {

let warrantyRemainingPeriodfinished = false;

if(detail) warrantyRemainingPeriodfinished = detail.warrantyRemainingMonths == 0? true : false
  
  const certSecurityPt2 = () => {
    switch (detail.typeCardToShow) {
            
        case "stamp-available" : 
        return i18n.t('badge_status.modalOKavaliableStamp-finishWarrantyPt2')
        

        case "stamp-unavailable" : 
        return i18n.t('badge_status.modalnOKCertServicePt2')

        case "warranty-unavailable" :
        return i18n.t('badge_status.modalnOK')
        
        default : 
        return i18n.t('badge_status.modalnOK')

    }
}
  return (
    <Modal show={show} onHide={handleClose} className={"modal-detail"} size={"sm"} centered>
        <Modal.Body>
            <Container style={{marginBottom:"5px"}}>
                <Row > 
                <TitleHead
                        text={"Detalhes"}
                        color={MainStyles.colors.black}
                        size={'small'} 
                    />  
                {image}
                </Row>  
                {
                    !warrantyRemainingPeriodfinished &&
                    <Row>
                    {infoPeriod}
                    </Row>
                } 
                
                
            </Container>
            <Container style={{marginBottom: "10px"}}>
                <Row>
                    {text}
                
                    {
                        (!guaranteeStamp || warrantyRemainingPeriodfinished) && 
                        <TitleLight
                        ownClass={"modal-text"}
                        text={certSecurityPt2()}
                        color={MainStyles.colors.black}
                        size={'xsmall'} />
                    }
                </Row>
            </Container>
            {guaranteeStamp&& button}
            {!guaranteeStamp &&   
                <WhiteButton                
                    text={"Ok, entendi"}
                    isRounded={true}
                    marginTop
                    onClick={handleClose}
                    
                />}
        </Modal.Body>
      </Modal>
  )
}

export default ModalDetails